import { cx } from '@emotion/css';
import { faClone } from '@fortawesome/free-regular-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { useCallback, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import Button from '../Button';

import {
  actionClassName,
  bannerClassName,
  buttonSuccessClassName,
  copyButtonClassName,
  copyLinkClassName,
  iconClassName,
  inputClassName,
  wrapperClassName,
} from './styles';
import { CopyLinkProps } from './types';

type Props = CopyLinkProps;

const CopyLink = ({ url, buttonClassName, textClassName, onCopy }: Props) => {
  const [copied, setCopied] = useState<boolean>(false);

  const handleCopy = useCallback(() => {
    setCopied(true);
    setTimeout(() => {
      if (onCopy) {
        onCopy();
      }
      setCopied(false);
    }, 1500);
  }, [onCopy]);

  return (
    <div className={copyLinkClassName}>
      <div className={wrapperClassName}>
        <input
          className={cx(inputClassName, textClassName)}
          value={url}
          readOnly
        />
        <div className={actionClassName}>
          {/** @ts-expect-error: 'CopyToClipboard' cannot be used as a JSX component */}
          <CopyToClipboard text={url} onCopy={handleCopy}>
            <Button
              className={cx(copyButtonClassName, buttonClassName, {
                [buttonSuccessClassName]: copied,
              })}
              iconClassName={iconClassName}
              faIcon={copied ? faCheck : faClone}
            />
          </CopyToClipboard>
        </div>
      </div>
      {copied && <div className={bannerClassName}>Copied to clipboard!</div>}
    </div>
  );
};

CopyLink.displayName = 'CopyLink';

export default CopyLink;
